import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchCustomersAPI,
    selectNoData as selectNoCustomerData,
    selectPage,
} from "../../../app/customerSlice";
import { getPageTitle } from "../../../shared/sessionUtility";
import CustomerQuickSearch from "../../sharedComponents/CustomerQuickSearch";
import NoData from "../NoData";
import CustomerGrid from "./CustomerGrid";

const customers = React.memo(() => {
    const dispatch = useDispatch();
    const pageData = useSelector(selectPage);
    const noCustomerData = useSelector(selectNoCustomerData);

    useEffect(() => {
        dispatch(fetchCustomersAPI());
    }, [dispatch]);

    return (
        <React.Fragment>
            <Helmet>
                <title>{dispatch(getPageTitle("Customers"))}</title>
            </Helmet>

            <div className="dl-search">
                <div className="pad-bottom-sm cx-quick-search">
                    <CustomerQuickSearch />
                </div>
                <h1 className="line-height-md">Customers</h1>
                <div hidden={!pageData.data.length && noCustomerData === "onLanding"}>
                    <CustomerGrid />
                </div>
                <div className="flex dl-flex-fill-height ">
                    <NoData hidden={pageData.data.length} />
                </div>
            </div>
        </React.Fragment>
    );
});

export default customers;
